// extracted by mini-css-extract-plugin
export default {"chipContainer":"betChips_chipContainer__XO5S2","chip":"betChips_chip__wnm-V"};